import camelcaseKeys from 'camelcase-keys'
import { create } from 'zustand'

import { executeGet } from '@/services/lukita'
import type { Plan } from './types'

type PlansStoreActions = {
  setPlans: (plans: Plan[]) => void
  startLoadingPlans: () => void
  stopLoadingPlans: () => void
}

type PlansStoreMutations = {}

type PlansStoreLoaders = {
  fetchPlans: () => Promise<void>
}

export interface PlansStore {
  plans: Plan[] | []
  loadingPlans: boolean
  actions: PlansStoreActions
  mutations: PlansStoreMutations
  loaders: PlansStoreLoaders
}

export const usePlansStore = create<PlansStore>()((set, get) => ({
  plans: [],
  loadingPlans: false,
  actions: {
    setPlans: (plans) => set({ plans: camelcaseKeys(plans) }),
    startLoadingPlans: () => set({ loadingPlans: true }),
    stopLoadingPlans: () => set({ loadingPlans: false }),
  },

  mutations: {},

  loaders: {
    fetchPlans: async () => {
      const { actions } = get()
      actions.startLoadingPlans()
      const response = await executeGet('/prices')
      const result = await response.json()
      actions.setPlans(result)
      actions.stopLoadingPlans()
    },
  },
}))
